import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ProtectedRoute from "./components/protectedRoute";
import CssBaseline from "@mui/material/CssBaseline";
import TopNav from "./pages/TopNav";
import LeftNav from "./pages/LeftNav";
import Home from "./pages/Home";
import Hustle from "./pages/Hustle";
import Events from "./pages/Events";
import Reports from "./pages/Reports";
import Orders from "./pages/Orders";
import Viewer from "./pages/Viewer";
import Login from "./pages/Login";
import Settings from "./pages/Settings";
import "./App.css";

function AppContent() {
  const location = useLocation();
  const locPath = location.pathname;
  const noNavs = ["/viewer", "/login"];
  const displayNavs = noNavs.some((path) => locPath.includes(path));
  return (
    <>
      <CssBaseline />
      {!displayNavs && <TopNav />}
      {!displayNavs && <LeftNav />}
      <main
        style={{
          padding: displayNavs ? 0 : 20,
          marginLeft: displayNavs ? 0 : 100,
        }}>
        <Routes>
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
          <Route
            path="/hustle"
            element={
              <ProtectedRoute>
                <Hustle />
              </ProtectedRoute>
            }
          />
          <Route
            path="/events"
            element={
              <ProtectedRoute>
                <Events />
              </ProtectedRoute>
            }
          />
          <Route
            path="/reports"
            element={
              <ProtectedRoute>
                <Reports />
              </ProtectedRoute>
            }
          />
          <Route
            path="/orders"
            element={
              <ProtectedRoute>
                <Orders />
              </ProtectedRoute>
            }
          />
          <Route
            path="/viewer"
            element={
              <ProtectedRoute>
                <Viewer />
              </ProtectedRoute>
            }
          />
          <Route
            path="/Settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route path="login" element={<Login />} />
          <Route
            path="*"
            element={
              <ProtectedRoute>
                <Home />
              </ProtectedRoute>
            }
          />
        </Routes>
      </main>
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}
